module.exports = __webpack_public_path__ + "img/vr看房.55776ace.png";